<template>
  <form class="header-search" @submit.prevent="onSubmit">
    <label class="header-search__label">
      <span class="header-search__visually-hidden">Search</span>
      <button type="submit" class="header-search__icon" aria-label="Search" />
      <input
        id="search-query"
        name="search-query"
        v-model="query"
        type="search"
        placeholder="Search"
        class="header-search__input"
      />
    </label>
  </form>
</template>

<script src="./header-search.js"></script>
<style src="./header-search.scss" lang="scss"></style>
